import { DashboardTab } from './DashboardTab'

export default DashboardTab
